import { render } from "./AssignedClients.vue?vue&type=template&id=7d36e08e&ts=true"
import script from "./AssignedClients.vue?vue&type=script&lang=ts"
export * from "./AssignedClients.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__